import { format } from "date-fns";
import { Train, Phone, Mail, MapPin } from "lucide-react";

export function Foot() {
  const year = format(new Date(), "yyyy");
  return (
    <footer className="bg-gray-800 text-white py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left Column - Company Info */}
          <div>
            <div className="flex items-center mb-5">
              <div className="h-12 flex items-center justify-center mr-3">
                <img src="/logo-head.png" alt="ЭИС" className="h-7 object-contain" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">ЭИС</h3>
                <p className="text-orange-400 text-sm">Электронная Информационная Система</p>
              </div>
            </div>

            <p className="text-gray-300 text-sm leading-relaxed mb-7">
              Электронная Информационная Система - это единая цифровая среда для встречи спроса и
              предложения в сфере железнодорожных перевозок.
            </p>

            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-orange-400" />
                <a href="tel:+7 (800) 700-19-94">8 (800) 700 19 94</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-orange-400" />
                <a href="mailto:eis@it4prof.ru">eis@it4prof.ru</a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-orange-400" />
                <span>г.Краснодар, ул.Рашпилевская, дом 256</span>
              </div>
            </div>
          </div>

          {/* Center Column - Documents */}
          <div>
            <h4 className="text-lg font-bold mb-[26px] text-orange-400 uppercase">ДОКУМЕНТЫ</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <a
                  href="/user_agreement.pdf"
                  target="_blank"
                  className="hover:text-white transition-colors"
                >
                  Пользовательское соглашение
                </a>
              </li>
              <li>
                <a
                  href="/privacy_policy.pdf"
                  target="_blank"
                  className="hover:text-white transition-colors"
                >
                  Правила конфиденциальности
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column - Support & Registration */}
          <div>
            <h4 className="text-lg font-bold mb-[26px] text-orange-400 uppercase">Поддержка</h4>

            <div className="bg-gray-700 rounded-lg p-4 mb-5">
              <p className="text-sm text-gray-300 mb-3">Техподдержка</p>
              <p className="font-semibold text-white">
                <a href="tel:+7 (800) 200-29-70">8 (800) 200 29 70</a>
              </p>
              <a href="mailto:info@it4prof.ru">info@it4prof.ru</a>
              <p className="text-xs text-gray-400">Круглосуточно</p>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
            <p>{year} ЭИС. Все права защищены.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
